import { ReactElement, useLayoutEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import OtpInput from 'react-otp-input';
import { Box, Typography, Grid } from '@mui/material';
// import { AuthenticationService } from 'services';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import { Utils } from 'shared/helpers';
import { AuthActions } from 'state/authentication/Action';
import { UserSettingService } from 'services/UserSettingService';
import { SocketService } from 'services';
import { SocketActions } from 'state/socket/Action';

const SecurityVerificationForm = (props: any): ReactElement => {
    const { setLoginData, authState, setSocketHandshake } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const { tokenId }: any = location.state;

    const [isSubmitting, setisSubmitting] = useState(false);
    const [token, setToken] = useState('');

    // API Calls
    const securityVerification = (values: any, callback: any): void => {
        UserSettingService.securityVerification(values)
            .then((response: any) => {
                callback(true, response);
            })
            .catch((error: any) => {
                callback(false);
                Utils.handleErrorResponse(error);
            });
    };
    useLayoutEffect(() => {
        if (authState.isUserLoggedIn) {
            SocketService.getSocketToken()
                .then((response) => {
                    const { data } = response;
                    const {
                        data: { url },
                    } = data;

                    setSocketHandshake(url);
                })
                .catch((error) => {
                    Utils.handleErrorResponse(error);
                });
        }
    }, [authState.accessToken, authState.isUserLoggedIn]);
    // UI Actions
    const actionSecurityVerification = (): void => {
        const requestObj = {
            code: token,
            tokenId,
        };
        setisSubmitting(true);
        securityVerification(requestObj, (status: any, response: any) => {
            setisSubmitting(false);
            if (status) {
                const { data } = response.data;
                if (data.email.verified) {
                    setLoginData({ ...data, isUserLoggedIn: true });
                    setTimeout(() => {
                        navigate('/dashboard', { replace: true });
                    }, 500);
                }
            }
        });
    };

    const actionOnChange = (otp: any): void => setToken(otp);

    const otpPinDisable = (): any => {
        if (Object.entries(token).length === 6 || isSubmitting === true)
            return false;
        return true;
    };

    // UI Elements
    return (
        <form>
            <Box className="security-verification-wrapper">
                <Typography className="title" variant="h5">
                    Security Verification
                </Typography>

                <Typography className="subtitle" variant="body1">
                    To secure you account, please complete the following
                    verification.
                </Typography>

                <Typography className="header" variant="h6">
                    Google verification code
                </Typography>

                <Box className="py-6">
                    <Grid container>
                        <Grid item lg={3} md={4} sm={6} xs={12}>
                            <OtpInput
                                value={token}
                                onChange={actionOnChange}
                                numInputs={6}
                                inputStyle="input-otp"
                                isInputNum
                                isInputSecure
                                shouldAutoFocus
                                separator={<span className="input-split" />}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box pt={3}>
                    <Grid container alignItems="center" justifyContent="center">
                        <Grid item xs={12} sm={6}>
                            <Link to="/login" className="link">
                                Back to Login
                            </Link>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box mt={4} mb={3}>
                                <AppPrimaryButton
                                    fullWidth
                                    title="Verify"
                                    isLoading={isSubmitting}
                                    loadingSize={22}
                                    loadingText="VERIFYING"
                                    disabled={otpPinDisable() || isSubmitting}
                                    onClick={actionSecurityVerification}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </form>
    );
};

const mapStateToProps = (state: any): any => ({
    authState: state.authState,
});

const mapDispatchToProps = (dispatch: any): any => ({
    setSocketHandshake: (data: string) =>
        dispatch(SocketActions.SetSocketInitialHandshake(data)),
    setLoginData: (data: any) => dispatch(AuthActions.setLoginStatus(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SecurityVerificationForm);
